<template>
	<div class="MAM_stockList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="stockForm" class="demo-form-inline">

				<el-form-item>
					<el-input size clearable v-model="stockForm.real_name" placeholder="申请人"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.agent_no" placeholder="申请人编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.apply_num" placeholder="申请单号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.phone" placeholder="申请人账号"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="stockForm.s_nickname" placeholder="所属机构昵称"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="stockForm.s_agent_no" placeholder="所属机构编号"></el-input>
                </el-form-item>
				<el-form-item>
					<el-select size clearable v-model="stockForm.status" placeholder="兑换状态" style="width:180px;">
						<el-option label="全部" value="">全部</el-option>
						<el-option label="待接受" :value="0">待接受</el-option>
						<el-option label="已接受" :value="1">已接受</el-option>
                        <el-option label="已拒绝" :value="2">已拒绝</el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
                	<el-select size clearable v-model="stockForm.parent_ident" placeholder="兑换对象" style="width:180px;">
                		<el-option label="直接推荐人" :value="1">直接推荐人</el-option>
                		<el-option label="运营中心" :value="2">运营中心</el-option>
                		<el-option label="其他推荐人" :value="3">其他推荐人</el-option>
                        <el-option label="总部" :value="4">总部</el-option>
                	</el-select>
                </el-form-item>

				<el-form-item>
					<el-date-picker size clearable v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="申请开始日期" end-placeholder="申请结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(stockForm)">查询</el-button>
                    <el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
                    	:loading="downLoading2" @click="handleDownLoad2(stockForm)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading"
@selection-change="changeFun">

				<el-table-column type="selection" width="55" :selectable="selectable">
				</el-table-column>
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>
				<el-table-column header-align="center" align="center" prop="apply_num" label="申请单号"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="real_name" label="申请人" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="申请人编号" min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="申请人账号" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="s_nickname" label="所属机构昵称" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="s_agent_no" label="所属机构编号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="brand_name" label="兑换政策" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="parent_ident_text" label="兑换对象" min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="nums" label="兑换台数"
					min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="points" label="消耗积分"
                	min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="apply_time" label="申请时间"
					min-width="160"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status" label="兑换状态" min-width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0" style="color: #E89E42;">待接受</span>
						<span v-if="scope.row.status == 1" style="color: #81B437;">已接受</span>
                        <span v-if="scope.row.status == 2" style="color: #C72A29;">已拒绝</span>
					</template>
				</el-table-column>
                <el-table-column header-align="center" align="left"  label="收货地址" min-width="200">
                	<template slot-scope="scope">
                		<div>{{scope.row.address}}</div>
                        <div>
                            <span>{{scope.row.addr_name}}</span>
                            <span style="marginLeft:20px;">{{scope.row.addr_phone}}</span>
                        </div>
                	</template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="remark" label="备注"
                	min-width="160"></el-table-column>
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="120">
					<template slot-scope="scope">
						<el-button v-if="scope.row.status == 0" @click="handleInfo(scope.row)" type="text" size="small">处理兑换</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
        
        <el-dialog
          title="温馨提示"
          :visible.sync="dialogVisible"
          width="30%">
          <span>{{dialogMessage}}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="duiHuanClick(2)">拒 绝</el-button>
            <el-button type="primary" @click="duiHuanClick(1)">接 受</el-button>
          </span>
        </el-dialog>
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "newExchangeManagement",
		data() {
			return {
				level: sessionStorage.getItem('level'),
				rangeDate: '',
				stockForm: {
					real_name: '',
					phone: '',
					agent_no: '',
					status: 0,
					apply_num: '',
					start_time: '',
					end_time: '',
                    parent_ident:'',
                    s_nickname:'',
                    s_agent_no:''
				},
				stockTable: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,

				//弹框
				dialogVisible: false,
                dialogMessage: '',
				detailsState: false,
				detailsTable: {
					list: [],
				},
				detailspage: {
					detailscurrentPage: 1, //当前页码
					detailspageSize: 10, //条数
					detailstotal: 0 //总数
				},
				detailsForm: {
					page: 1,
					limit: 10,
					apply_id: null,
					user_id: null,
				},
				//导出
				downLoading:false,
                downLoading2:false,
				listRow: [],
			}
		},
		mounted() {
			//初始化
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				status: 0,
			})
		},
		components: {
			paginations,
		},
		methods: {
			//勾选
			changeFun(row) {
				this.listRow = row;
			},
			selectable(row, index) {
				if (row.status == 1) {
					return true; //不禁用
				} else {
					return false; //禁用
				}
			},
            handleDownLoad2(params) {
            	let reqData = {
            		type: 29,
            		value: JSON.stringify(params),
            	};
            	this.downLoading2 = true;
            	this.$api.post('export/add', reqData, res => {
            		if (res.code == 0) {
            			this.$message.success(res.msg);
            			this.downLoading2 = false;
            		} else {
            			this.$message.error(res.msg);
            			this.downLoading2 = false;
            		}
            
            	})
            },

			handleInfo(row, state) {
				this.detailsForm = {
					apply_id: row.id,
				}
                this.dialogMessage = `是否接受本次兑换申请【${row.nums}台】【${row.points}积分】`
                this.dialogVisible = true;
			},
            duiHuanClick(status){
                this.dialogVisible = false;
                let data = {
                	id: this.detailsForm.apply_id,
                	status: status,
                }
                this.$api.post("terminal_exchange/confirmPointApply", data, res => {
                	if (res.code == 0) {
                		this.$message.success({
                			type: 'success',
                			message: '操作成功',
                		});
                        this.stockForm.page = this.page.currentPage;
                        this.stockForm.limit = this.page.pageSize;
                        this.getData(this.stockForm);
                	} else {
                		this.$message.error(res.msg);
                	}
                	//渲染结束后取消加载
                	this.loading = false;
                });

            },
			pickerChange(DateArr) { //时间选择器
				this.stockForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.stockForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},

			onSearch(stockForm) {
				this.page.currentPage = 1;
				stockForm.page = this.page.currentPage;
				stockForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(stockForm);
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.loading = true;
				this.page.currentPage = page;
				this.stockForm.page = page;
				this.stockForm.limit = this.page.pageSize;
				this.getData(this.stockForm)
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.loading = true;
				this.page.pageSize = limit;
				this.stockForm.page = this.page.currentPage;
				this.stockForm.limit = limit;
				this.getData(this.stockForm);
			},
			getData(params) {
				this.$api.post("terminal_exchange/TerminalPointExchangePage", params, res => {
					let data = res.data;
					this.page.total = data.total; //总数
					this.stockTable.list = data.data;
					//渲染结束后取消加载
					this.loading = false;
				});
			}
		},

	};
</script>

<style lang="scss" scope>
	.MAM_stockList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>